import Swal from "sweetalert2";
import api from "./api";

export const download = async (hash: string) => {
  await api
    .get(`/baixa-documento?arq=${hash}`)
    .then((res) => {
      window.open(res.data.url, "_blank");
    })
    .catch((error) => {
      console.log("erro: ", error);
      Swal.fire({
        icon: "warning",
        title:
          "Erro ao baixar o arquivo! Tente novamente ou entre em contato com o administrador do sistema",
        showConfirmButton: true,
        confirmButtonText: `Ok`,
      });
    });
};
